import { render } from "./ProductsTables.vue?vue&type=template&id=808eb850&scoped=true"
import script from "./ProductsTables.vue?vue&type=script&lang=js"
export * from "./ProductsTables.vue?vue&type=script&lang=js"

import "./ProductsTables.vue?vue&type=style&index=0&id=808eb850&lang=scss&scoped=true"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-808eb850"]])

export default __exports__